export default __webpack_public_path__ + "static/media/N-06.b78a971e.png";